//
// DownloadStatus.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../TransportModel";
import "./ReportAsset";

var DownloadStatus = createModule("transport::DownloadStatus", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel"], EventDispatcher, [
    ,
    {
        numberOfRequiredAssets: 4,
        numberOfFailedDownloads: 4,
        isPaused: 2,
        numberOfDownloadsInProgress: 4,
        assets: [1],
        numberOfPendingDownloads: 4,
        needsPreviewsGenerated: 2,
        numberOfAvailableAssets: 4,
        needsThumbnailsDownloaded: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default DownloadStatus;
